export default __webpack_public_path__ + "static/media/image.zodiumvalley-pvt-ltd-.b8bbb059.png";